"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactPopper = require("react-popper");

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _useTrigger2 = _interopRequireDefault(require("../../hooks/useTrigger"));

var _useToggler2 = _interopRequireDefault(require("../../hooks/useToggler"));

var _excluded = ["trigger", "id", "position", "children", "className", "width"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Tooltip component provides a way to display additional information when an user hover another UI element.
 *
 * This component is an opinionated wrapper around <a href="https://github.com/popperjs/react-popper">ReactPopper</a>.
 */
var Tooltip = function Tooltip(props) {
  var initialTrigger = props.trigger,
      controlledId = props.id,
      position = props.position,
      children = props.children,
      className = props.className,
      width = props.width,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var tooltipRef = _react.default.useRef(null);

  var id = _react.default.useRef((0, _useRandomId.default)(controlledId)).current;

  var _useToggler = (0, _useToggler2.default)(null),
      isOpen = _useToggler.isOpen,
      setOpen = _useToggler.setOpen,
      setClose = _useToggler.setClose;

  var _useTrigger = (0, _useTrigger2.default)(initialTrigger, _extends({}, initialTrigger.props, {
    className: (0, _clsx.default)('uk-tooltip__trigger', initialTrigger.props && initialTrigger.props.className),
    'aria-describedby': id || undefined
  })),
      trigger = _useTrigger.trigger;

  var handleOnEscPress = _react.default.useCallback(function (e) {
    if (e.keyCode === 27) {
      setClose();
    }
  }, [setClose]);

  var handleOnFocus = function handleOnFocus() {
    if (!isOpen) {
      setOpen();
    }
  };

  var handleOnBlur = function handleOnBlur() {
    if (isOpen) {
      setClose();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: tooltipRef,
    className: (0, _clsx.default)('uk-tooltip', isOpen && 'is-active', className),
    role: "tooltip",
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onKeyDown: function onKeyDown(e) {
      return handleOnEscPress(e);
    }
  }, attributes), /*#__PURE__*/_react.default.createElement(_reactPopper.Manager, null, /*#__PURE__*/_react.default.createElement(_reactPopper.Reference, null, function (_ref) {
    var ref = _ref.ref;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: ref
    }, trigger);
  }), /*#__PURE__*/_react.default.createElement(_reactPopper.Popper, {
    placement: position
  }, function (_ref2) {
    var ref = _ref2.ref,
        placement = _ref2.placement;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: ref,
      "data-placement": placement,
      className: "uk-tooltip__content",
      id: id,
      style: width ? {
        minWidth: width
      } : {}
    }, children);
  })));
};

/*#__PURE__*/
_react.default.createElement("div", {
  class: "text"
}, /*#__PURE__*/_react.default.createElement("label", {
  id: "tp1-label",
  for: "first"
}, "First Name:"), /*#__PURE__*/_react.default.createElement("input", {
  type: "text",
  id: "first",
  name: "first",
  size: "20",
  "aria-labelledby": "tp1-label",
  "aria-describedby": "tp1",
  "aria-required": "false"
}), /*#__PURE__*/_react.default.createElement("div", {
  id: "tp1",
  class: "tooltip",
  role: "tooltip",
  "aria-hidden": "true"
}, "Your first name is optional"));

Tooltip.propTypes = {
  /**
   * ID used to meet accessibility standards (WAI-ARIA Tooltip Pattern)
   * NB: the ID will be randomly generated if not set.
   */
  id: _propTypes.default.string,

  /**
   * Trigger of the Tooltip
   * If the trigger isn't a React element, it will be wrapped within a <span/>
   */
  trigger: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,

  /**
   * Position of the tooltip relative to its trigger
   */
  position: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * Change width prop (default : auto)
   */
  width: _propTypes.default.string
};
Tooltip.defaultProps = {
  position: 'top'
};
var _default = Tooltip;
exports.default = _default;